export default "__VITE_ASSET__BkCq3m8g__"